module.exports = __webpack_public_path__ + "img/logo.553605cd.svg";